import Ocpr from "ocprjs";
import { loadCallback } from ".";
import {
  DEFAULT_BLOG_IMG_PLACEHOLDER,
  DEFAULT_CUSTOMER_IMG_PLACEHOLDER,
  DEFAULT_PRODUCT_IMG_PLACEHOLDER,
  IMG_BASE_URL,
} from "../constants";
import { ImageOutputModel, TCb } from "../models";

class ImageUtils {
  DEFAULT_COMPRESSION_CONFIG = {
    quality: 0.9,
    strict: true,
    maxWidth: 4096,
    width: 600,
    height: 600,
  };

  compress = (file: any, config: any, cb?: TCb) => {
    new Ocpr(file, {
      ...config,
      success: (result: any) => {
        loadCallback(cb?.success, result);
      },
      error(err) {
        loadCallback(cb?.fail, err);
      },
    });
  };

  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  getBase64WithCb = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      // message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      // message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  /**
   *
   * dùng cho upload của antd nếu ko up lên server
   */
  simulateRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  buildVariantImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.PRODUCT}/${img}` : DEFAULT_PRODUCT_IMG_PLACEHOLDER;
  };

  buildProductImgSrc = (img: ImageOutputModel | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.PRODUCT}/${img.picture}` : DEFAULT_PRODUCT_IMG_PLACEHOLDER;
  };

  buildProductCategoryImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.PRODUCT_CATEGORIES}/${img}` : undefined;
  };

  buildProductDescriptionImgSrc = (img: string): string => {
    return `${IMG_BASE_URL.PRODUCT_DESCRIPTION}/${img}`;
  };

  buildToppingImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.TOPPING}/${img}` : undefined;
  };

  buildBlogImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.BLOG}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildSolutionImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.SOLUTION}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };
  buildTechnologyImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.TECHNOLOGY}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildFocusedMarketImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.FOCUSED_MARKET}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildBannerImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.BANNER}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildCountryImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.COUNTRY}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildLanguageImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.LANGUAGE}/${img}` : undefined;
  };

  buildBlogCategoryImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.BLOG_CATEGORIES}/${img}` : undefined;
  };

  buildCustomerImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.CUSTOMER}/${img}` : DEFAULT_CUSTOMER_IMG_PLACEHOLDER;
  };

  buildCareerImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.CAREER}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  buildNewImgSrc = (img: string | undefined | null): string | undefined => {
    return img ? `${IMG_BASE_URL.NEWS}/${img}` : DEFAULT_BLOG_IMG_PLACEHOLDER;
  };

  convertImgServerSrc = (
    imgSrc: string,
    imgType: "product" | "blog" | "solution" | "banner" | "focusedMarket" | "career" | "country",
  ): string => {
    let serverSrc: string = "";

    switch (imgType) {
      case "product":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.PRODUCT}/`, "");
        break;

      case "blog":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.BLOG}/`, "");
        break;

      case "solution":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.SOLUTION}/`, "");
        break;

      case "banner":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.BANNER}/`, "");
        break;

      case "focusedMarket":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.FOCUSED_MARKET}/`, "");
        break;

      case "career":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.CAREER}/`, "");
        break;
      case "country":
        serverSrc = imgSrc.replace(`${IMG_BASE_URL.COUNTRY}/`, "");
        break;

      default:
        break;
    }

    return serverSrc;
  };
}

export const ImageUtil = new ImageUtils();
